export default "__VITE_ASSET__6lv7SXKT__"